import ModalActions from './modal-actions.connect'

export default ModalActions
